import { RequestService } from '../../../../common/services/RequestService';
import { GET_CUSTOMERS } from '../constants';
import { adjustCustomersData } from './adjustCustomersData';

export const getAllCustomers = async (companyId, search, sort) => {
  const query = {
    ...sort
  };

  if (search) {
    query['search'] = search;
  }

  const queryStr = '?' + (new URLSearchParams(query).toString());

  const response = await RequestService.get(
    GET_CUSTOMERS.replace('{company_id}', companyId) + queryStr
  );

  return response.data.map(customer => adjustCustomersData(customer));
};
